import io from 'socket.io-client';
import {eventChannel, delay} from 'redux-saga';
import {all, take, call, put, select, fork, race, cancelled, takeEvery} from 'redux-saga/effects';

import * as action from '../actions';
import * as selector from '../selectors';
import {socketServerURL, socketRoom} from '../config';

// wrapping functions for socket events (connect, disconnect, reconnect)
let socket;
const connect = () => {
	socket = io(socketServerURL, {
		query: {
			room: socketRoom,
			online: true,
		},
		secure: true,
		reconnect: true,
		rejectUnauthorized: false,
	});
	return new Promise(resolve => {
		socket.on('connect', () => {
			resolve(socket);
		});
	});
};

const disconnect = () => {
	return new Promise(resolve => {
		socket.on('disconnect', () => {
			resolve(socket);
		});
	});
};

const reconnect = () => {
	return new Promise(resolve => {
		socket.on('reconnect', () => {
			resolve(socket);
		});
	});
};

// This is how channel is created
const createSocketChannel = (socket, event) => eventChannel(emit => {
	socket.on(event, data => {
		emit(data);
	});

	return () => {
		socket.off(event);
	};
});

// connection monitoring sagas
const listenDisconnectSaga = function* () {
	while (true) {
		yield call(disconnect);
		yield put(action.socketServerOff());
	}
};

const listenConnectSaga = function* () {
	while (true) {
		yield call(reconnect);
		yield put(action.socketServerOn());
	}
};

const listenChangeSaga = function* (socket) {
	const socketChannel = yield call(createSocketChannel, socket, 'change');
	while (true) {
		const payload = yield take(socketChannel);
		const data = JSON.parse(payload);

		// если у пользователя открыта таблица броней на эту же дату, то обновляем
		const bookingDate = yield select(selector.getBookDate);
		if (data.date === bookingDate) {
			yield put(action.loadBookings.request({date: data.date}));
		}
	}
};

const listenOnlineSaga = function* () {
	const socketChannel = yield call(createSocketChannel, socket, 'online');
	while (true) {
		const payload = yield take(socketChannel);

		yield put(action.online({count: payload}));
	}
};

// Saga to switch on channel.
const socketSaga = function* () {
	try {
		const {timeout, socket} = yield race({
			socket: call(connect),
			timeout: delay(2000),
		});
		if (timeout) {
			// console.log('socket timeout');
			return yield put(action.socketServerOff());
		}
		yield fork(listenDisconnectSaga);
		yield fork(listenConnectSaga);
		yield put(action.socketServerOn());

		yield fork(listenChangeSaga, socket);
		yield fork(listenOnlineSaga, socket);
	} catch (error) {
		// console.log('socketSaga error', error);
	} finally {
		if (yield cancelled()) {
			socket.disconnect(true);
			yield put(action.socketServerOff());
		}
	}
};

export default function* sagas() {
	yield all([
		takeEvery(action.ready, socketSaga),
	]);
}


// saga listens for start and stop actions
// export const startStopChannel = function* () {
// 	while (true) {
// 		yield take(START_CHANNEL);
// 		yield race({
// 			task: call(listenServerSaga),
// 			cancel: take(STOP_CHANNEL),
// 		});
// 	}
// };



// WEBPACK FOOTER //
// ./src/sagas/socketSaga.js